class PackageInfo {
  constructor() {
    // Use requestAnimationFrame to ensure DOM is ready
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    // Initialize tooltips
    this.initTooltips();
    // Initialize quantity calculation
    this.initQuantityCalculation();
  }

  initTooltips() {
    const triggers = document.querySelectorAll(".package-info-trigger");
    if (!triggers.length) return;

    // Use event delegation for better performance
    document.addEventListener("mouseover", (e) => {
      const trigger = e.target.closest(".package-info-trigger");
      if (!trigger) return;

      const tooltip = trigger.nextElementSibling;
      if (!tooltip || !tooltip.classList.contains("package-info-tooltip"))
        return;

      tooltip.style.display = "block";
      requestAnimationFrame(() => {
        tooltip.style.opacity = "1";
      });
    });

    document.addEventListener("mouseout", (e) => {
      const trigger = e.target.closest(".package-info-trigger");
      if (!trigger) return;

      const tooltip = trigger.nextElementSibling;
      if (!tooltip || !tooltip.classList.contains("package-info-tooltip"))
        return;

      tooltip.style.opacity = "0";
      setTimeout(() => {
        if (tooltip.style.opacity === "0") {
          tooltip.style.display = "none";
        }
      }, 300);
    });

    // Handle click events
    document.addEventListener("click", (e) => {
      const trigger = e.target.closest(".package-info-trigger");
      if (trigger) {
        e.preventDefault();
        const tooltip = trigger.nextElementSibling;
        if (!tooltip || !tooltip.classList.contains("package-info-tooltip"))
          return;

        if (tooltip.style.display === "none" || !tooltip.style.display) {
          tooltip.style.display = "block";
          requestAnimationFrame(() => {
            tooltip.style.opacity = "1";
          });
        } else {
          tooltip.style.opacity = "0";
          setTimeout(() => {
            tooltip.style.display = "none";
          }, 300);
        }
      } else {
        // Close all tooltips when clicking outside
        const tooltips = document.querySelectorAll(".package-info-tooltip");
        tooltips.forEach((tooltip) => {
          tooltip.style.opacity = "0";
          setTimeout(() => {
            tooltip.style.display = "none";
          }, 300);
        });
      }
    });
  }

  formatNumber(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  initQuantityCalculation() {
    const quantityInput = document.querySelector('input[name="quantity"]');
    const totalQuantityElement = document.querySelector(".total-quantity");
    const quantityDropdown = document.getElementById("quantity-dropdown");

    if (!quantityInput || !totalQuantityElement) return;

    // Get initial package quantity
    const initialPackageQty = parseInt(totalQuantityElement.textContent) || 1;

    const updateTotalQuantity = () => {
      const currentQuantity = parseInt(quantityInput.value) || 1;
      const totalQuantity = currentQuantity * initialPackageQty;
      totalQuantityElement.textContent = `${currentQuantity} × ${initialPackageQty} = ${totalQuantity}`;
    };

    // Wait for a brief moment to ensure quantity value is set
    setTimeout(() => {
      // Get initial quantity from dropdown or input value
      const initialQuantity = quantityDropdown
        ? parseInt(quantityDropdown.value)
        : parseInt(quantityInput.value) || 1;

      // Set initial quantity in input if needed
      if (parseInt(quantityInput.value) !== initialQuantity) {
        quantityInput.value = initialQuantity;
      }

      // Initial calculation with correct quantity
      updateTotalQuantity();
    }, 100);

    // Listen for all possible quantity change events
    quantityInput.addEventListener("change", updateTotalQuantity);
    quantityInput.addEventListener("input", updateTotalQuantity);
    quantityInput.addEventListener("keyup", updateTotalQuantity);
    quantityInput.addEventListener("mouseup", updateTotalQuantity);

    // Listen for quantity dropdown changes
    if (quantityDropdown) {
      quantityDropdown.addEventListener("change", () => {
        quantityInput.value = quantityDropdown.value;
        updateTotalQuantity();
      });
    }

    // Listen for quantity button clicks
    const quantityWrapper = quantityInput.closest(".quantity-wrapper");
    if (quantityWrapper) {
      quantityWrapper.addEventListener("click", (e) => {
        if (e.target.matches(".quantity-down, .quantity-up")) {
          setTimeout(updateTotalQuantity, 10);
        }
      });
    }

    // Listen for variant changes
    document.addEventListener("variant:change", () => {
      setTimeout(updateTotalQuantity, 50);
    });

    // Listen for form changes
    const form = quantityInput.closest("form");
    if (form) {
      form.addEventListener("change", updateTotalQuantity);
    }
  }
}

// Initialize when DOM is loaded
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => new PackageInfo());
} else {
  new PackageInfo();
}
